import * as React from 'react';

import { CombinedPackageViewProps } from '../../components/list/package';
import ListPerformances from '../../components/list/performances';

const ListPackageView: React.StatelessComponent<CombinedPackageViewProps> = props => {

    function addToCart() {
        props.selectPackage(props.package, props.useUnseatedReserve);
    }

    const selectSubscriptionButton = (
        <button className="btn" onClick={() => {
            props.selectedPackage && props.useUnseatedReserve ?
                props.removeFromCart(props.package.id)
                : addToCart();
        }}>
            {props.selectedPackage && props.useUnseatedReserve ? props.text.removeButtonText : props.text.selectSubscriptionButtonText}
        </button>
    );

    return (
        <li key={props.package.id} data-package-id={props.package.id} className="ace-subs-item">
            <article>
                <div className="ace-subs-item-header align-items-center">
                    <h3 className="notranslate">
                        {props.package.title}
                    </h3>
                    <div className="ace-subs-item-select ace-hide-for-tablet">
                        {selectSubscriptionButton}
                    </div>
                </div>
                <div className="ace-production grid grid-4-8 space-top-md">
                    <div className="ace-production-content">
                        <div className={`rich-text stack-sm ${props.themeClass}`}>
                            {
                                props.package.facility.facilityDescription ?
                                    <p className="h6-style themed-location notranslate">
                                        <svg className="svg-icon svg-icon-text" aria-hidden="true" focusable="false">
                                            <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="#icon-location"></use>
                                        </svg>
                                        <span className="icon-location-title">{props.package.facility.facilityDescription}</span>
                                    </p>
                                    : null
                            }
                            {
                                props.package.numberOfPerformancesMessage ?
                                    <p className="small">{props.package.numberOfPerformancesMessage}</p>
                                    : null
                            }


                        </div>
                        <button className={`btn-secondary space-top-md dropdown-trigger ${props.showPerformances ? 'dropdown-trigger-up' : 'dropdown-trigger-down'}`}
                            onClick={props.toggleShowPerformances}>
                            {
                                props.showPerformances ? props.text.hidePerformancesText
                                    : props.text.showPerformancesText
                            }
                        </button>

                    </div>

                    <div className="">
                        <div className={props.showPerformances ? "show ace-production-filtered-performances" : "hide"}>
                            <ListPerformances filteredPerformances={props.packagePerformances} toggleShowPerformances={props.toggleShowPerformances} />
                        </div>
                        <div className="ace-show-for-tablet">
                            {selectSubscriptionButton}
                        </div>
                    </div>
                </div>

            </article>
        </li>
    )
}

export default ListPackageView;